import { render, staticRenderFns } from "./QCMoney.vue?vue&type=template&id=60a1b452&scoped=true"
import script from "./QCMoney.vue?vue&type=script&lang=js"
export * from "./QCMoney.vue?vue&type=script&lang=js"
import style0 from "./QCMoney.vue?vue&type=style&index=0&id=60a1b452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a1b452",
  null
  
)

export default component.exports